import { PageTag } from 'src/app/modules/shared/models/models';

export type SystemStatus = 'ONLINE' | 'OFFLINE' | 'DEMO';

export type ClientAppType = 'drift' | 'sixsense';

export type DashboardModule = 'accelerated' | 'audiences_n_goals';

export enum ClientAppId {
  Drift = 1,
  SixSense = 2
}

export type Status = 'active' | 'archived';

export interface SettingsAccountFeatures {
  name: string;
  supportOwner: string;
  currency: string;
  isoLanguage: string;
  trackingMA: string;
  usersLimit: number;
  identifyJourneys: boolean;
  showContentWizard: boolean;
  showOneToWon: boolean;
  showDeals: boolean;
  maDeals: boolean;
  hideCompaniesDashboard: boolean;
  hideCompaniesAssets: boolean;
  abm: boolean;
  showExactCompanyTargetList: boolean;
  abmMinCompanyResolvePages: number;
  abmCountriesIsExclude: boolean;
  abmCountriesToResolve: string[];
  abmAreasIsExclude: boolean;
  abmAreasToResolve: number[];
  abmPagesToExcludeResolve: string[];
  autotags: boolean;
  spa: boolean;
  survey: boolean;
  reportUpliftProvider: string;
  allAccountImpactAnalysis: boolean;
  trackingMethod: string;
  sendTrdActivityToMa: boolean;
  tryRescanPages: boolean;
  clientApps: ClientAppType[];
  pageviewsLimit: number | null;
  campaignImpsLimit: number | null;
  activeCampaignsLimit: number | null;
  sendMonthlyEmail: boolean;
  readMinScroll: number | null;
  aceSupport: boolean;
  dashboardScreenModules: DashboardModule[];
  useMfa: boolean;
  gaUpliftConfig: string;
  gaStreamConfig: string;
  contentFetchDomain: string;
  shortUrlDomain: string;
  redirectAvoidFlickering: boolean;
  aceFade: boolean;
  enableSailAccountData: boolean;
  companyJourneySummaryPrompt: string;
  companySegmentSummaryPrompt: string;
  slackChannlesHighScaleSupport: boolean;
  autoPilotEnabled: boolean;
  autopilotLanguage: string;
  accountType: AccountType | null;
  planConfig: PlanDetails;
  status: Status;
  restrictCookieToSubdomain: boolean;
  salesforceAmountField: string;
  dashboardDataStartDate: string;
  contexTilesEnabled: boolean;
  cookielessTrackingSupport: boolean;
  complianceSoftware: string;
  complianceVariable: string;
  accessibilitySupport: boolean;
  reportsAttachments: boolean;
  superStrictMode: boolean;
  enableCsNotifications: boolean;
}

export interface PlanDetails {
  planName: string;
  customPlanDescription: string;
  supportTier: string;
  customSupportTierDescription: string;
  renewalDate: string;
}

export interface PlanDescription {
  planNameDescription: string;
  supportTierDescription: string;
}

export interface SettingsAccountDetails {
  systemStatus: SystemStatus;
  isFriendlyUrl: boolean;
  isCodeOnline: boolean;
  spaRegex: string;
}

export interface CsAgentConfig {
  csAgentContext: string | null;
}

export interface SettingsAreasReponse {
  areas: SettingsArea[];
  pageTags: PageTag[];
}

export interface SettingsDomainResponse {
  siteDomain: string;
  domains: SettingsDomain[];
}

export interface SettingsIgnoredIps {
  ips: string[];
  masks: string[];
}

export interface SettingsArea {
  id: number;
  name: string;
  url: string;
  pull_content: boolean;
  content_type: 'content' | 'general';
  area_order: number;
  area_by: 'tag' | 'url';
  area_tags: number[];
}

export interface SettingsDomain {
  id: number;
  domain: string;
}

export interface SettingsTags {
  tag: PageTag;
  usedInAreas: number;
  usedInCtas: number;
  usedInCtxTilesPoolConfig: number;
  usedInContentPoolConfig: number;
}

export interface SettingsPersonalization {
  ctaLifeTimeHours: number;
  isGoogleAnalyticsTracking: boolean;
  isGetWeeklyLeadsList: boolean;
  sliderAllocation: string;
  includeOggImage: boolean;
  isFullImageSearch: boolean;
  resizeType: ImageResizeType;
  weekHitsLimit: number;
  contentLifeTimeDays: number;
  useUtm: false;
  utmCode: string;
  excludeTitles: ExcludeTitle[];
  titleTag: string;
  titleClass: string;
  titleId: string;
  autoTagSelectors: string[];
  autoTagLimit: number | null;
}

export enum ImageResizeType {
  NoResize = -1,
  ResizeAndCrop_KeepAspectRatio = 0,
  Resize_NoAspectRatio = 1,
  ResizeFixedWidth_KeepAspectRatio = 2,
}

export interface ExcludeTitle {
  id: number;
  titleTemplate: string;
}

export interface PageDeduplication {
  id: number;
  pattern: string;
}

export interface AccountSummary {
  id: number;
  accountHasSurveys: boolean;
  accountHasLeadGenUnits: boolean;
  accountHasUnits: boolean;
  goalsConfigured: boolean;
  codeInstalled: boolean;
  inWizard: boolean;
  accountType: AccountType;
  selfStartWizardCompleted: boolean;
  isOfferConfigured: boolean;
  isAudienceConfigured: boolean;
  isOrchestrationConfigured: boolean;
  isAutopilotConfigured: boolean;
  isCompanySegmentConfigured: boolean;
}

export interface IImpactBlock {
  label: string;
  value: string;
  fromTotal: number;
}

export enum AccountType {
  Unknown,
  Paid,
  FreeTrial,
  PartnerAccount
}
